export const normalizeScopeId = (value) => (
  value === undefined || value === null || value === '' ? null : String(value)
);

export const getPrimarySchoolId = (user) => normalizeScopeId(
  user?.schoolId ?? user?.school_id ?? user?.schoolID ?? user?.schoolIds?.[0] ?? user?.school_ids?.[0]
);

export const getSchoolIdFromItem = (item) => normalizeScopeId(
  item?.schoolId ?? item?.school_id ?? item?.schoolID ?? item?.classSchoolId ?? item?.class_school_id
);

export const getClassSchoolId = (classes = [], classId) => {
  const normalizedClassId = normalizeScopeId(classId);
  if (!normalizedClassId) return null;
  const selectedClass = classes.find((item) => normalizeScopeId(item?.id ?? item?.classId ?? item?.class_id) === normalizedClassId);
  return getSchoolIdFromItem(selectedClass);
};

export const resolveDefaultSchoolId = (user, availableSchools = []) => {
  const schoolIds = new Set(availableSchools.map((school) => normalizeScopeId(school?.id ?? school?.schoolId ?? school?.school_id)).filter(Boolean));
  const primarySchoolId = getPrimarySchoolId(user);
  if (primarySchoolId && schoolIds.has(primarySchoolId)) return primarySchoolId;

  const classSchoolIds = (user?.classes || [])
    .map(getSchoolIdFromItem)
    .filter(Boolean);
  const classSchoolId = classSchoolIds.find((schoolId) => schoolIds.has(schoolId));
  if (classSchoolId) return classSchoolId;

  // A profile's legacy primary school is not proof of current access. When the
  // API returned an authorized list, default only within that list.
  return normalizeScopeId(availableSchools[0]?.id ?? availableSchools[0]?.schoolId ?? availableSchools[0]?.school_id)
    || (availableSchools.length === 0 ? primarySchoolId : null);
};

export const resolveOperationSchoolId = ({
  classes = [],
  classId,
  item,
  selectedSchoolId,
  user
} = {}) => (
  getClassSchoolId(classes, classId)
  || getSchoolIdFromItem(item)
  || normalizeScopeId(selectedSchoolId)
  || getPrimarySchoolId(user)
);

export const isSchoolInAccessibleList = (schoolId, availableSchools = []) => {
  const normalizedSchoolId = normalizeScopeId(schoolId);
  return Boolean(normalizedSchoolId && availableSchools.some(
    (school) => normalizeScopeId(school?.id ?? school?.schoolId ?? school?.school_id) === normalizedSchoolId
  ));
};

export const shouldLockSchoolSelection = (user, availableSchools = []) => (
  user?.role === 'school_admin' && availableSchools.length === 1
);
